import * as ModuleIcons from '@factorialco/factorial-one-react/icons/modules'

import i18n from 'modules/core/lib/i18n'

export const moduleMapper: Record<string, string> = {
  'clock-in': 'time-tracking',
  'project-management': 'projects',
  project_management: 'projects',
  timeoff: 'time-off',
  my_trainings: 'trainings',
  'new-trainings': 'trainings',
  my_expenses: 'expenses',
  ats: 'recruitment',
  'performance-v2': 'performance',
  reports: 'analytics',
  spendings: 'expenses',
  payroll_bundle: 'payroll',
  shifts: 'shift-management',
  space_control: 'space-management',
  finance: 'accounts-payable',
  it_management: 'it-management',
  processes: 'workflows',
  performance_v2: 'performance',
  employees: 'factorial-core',
  profile: 'factorial-core',
  documents: 'documents',
}

export const getModuleReadableName = (key: string): string => {
  switch (key) {
    case 'clock-in':
    case 'time-tracking':
      return i18n.t('product_updates.notification_widget.module_mappers.time_tracking')
    case 'documents':
      return i18n.t('product_updates.notification_widget.module_mappers.documents')
    case 'project-management':
    case 'project_management':
      return i18n.t('product_updates.notification_widget.module_mappers.projects')
    case 'timeoff':
      return i18n.t('product_updates.notification_widget.module_mappers.time_off')
    case 'my_trainings':
    case 'new-trainings':
      return i18n.t('product_updates.notification_widget.module_mappers.trainings')
    case 'my_expenses':
    case 'spendings':
      return i18n.t('product_updates.notification_widget.module_mappers.expenses')
    case 'ats':
      return i18n.t('product_updates.notification_widget.module_mappers.recruitment')
    case 'performance-v2':
    case 'performance_v2':
      return i18n.t('product_updates.notification_widget.module_mappers.performance')
    case 'reports':
      return i18n.t('product_updates.notification_widget.module_mappers.analytics')
    case 'payroll_bundle':
      return i18n.t('product_updates.notification_widget.module_mappers.payroll')
    case 'shifts':
      return i18n.t('product_updates.notification_widget.module_mappers.shift_management')
    case 'space_control':
      return i18n.t('product_updates.notification_widget.module_mappers.space_management')
    case 'finance':
      return i18n.t('product_updates.notification_widget.module_mappers.accounts_payable')
    case 'it_management':
      return i18n.t('product_updates.notification_widget.module_mappers.it_management')
    case 'processes':
      return i18n.t('product_updates.notification_widget.module_mappers.workflows')
    case 'employees':
    case 'profile':
      return i18n.t('product_updates.notification_widget.module_mappers.factorial_core')
    default:
      return key
  }
}

export const moduleIcons = (moduleIdentifier: string) => {
  switch (moduleIdentifier) {
    case 'projects':
      return ModuleIcons.Projects
    case 'shift_management':
      return ModuleIcons.Shifts
    case 'benefits':
      return ModuleIcons.Benefits
    case 'space_control':
      return ModuleIcons.Spaces
    case 'finance':
      return ModuleIcons.Finance
    case 'trainings':
      return ModuleIcons.Trainings
    case 'ats':
      return ModuleIcons.Recruitment
    case 'reviews':
      return ModuleIcons.Performance
    case 'goals':
      return ModuleIcons.Performance
    case 'competencies':
      return ModuleIcons.Performance
    case 'engagement_insights':
      return ModuleIcons.Engagement
    case 'surveys':
      return ModuleIcons.Engagement
    case 'enps':
      return ModuleIcons.Engagement
    case 'expenses':
      return ModuleIcons.Spending
    case 'timeoff':
      return ModuleIcons.TimeOff
    case 'time_tracking':
      return ModuleIcons.TimeTracking
    case 'procurement':
      return ModuleIcons.Spending
    case 'accounts_payable':
      return ModuleIcons.Spending
    case 'sales':
      return ModuleIcons.Sales
    default:
      return ModuleIcons.Discover
  }
}
